export const validTypes = [
    "image/png",       // PNG
    "image/jpeg",      // JPEG
    "image/jpg",       // JPG
    "image/gif",       // GIF
    "image/bmp",       // BMP
    "image/webp",      // WEBP
    "image/heic",      // HEIC
    "image/heif",      // HEIF
    "application/pdf", // PDF
    "application/msword", // Microsoft Word (.doc)
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Microsoft Word (.docx)
    "application/vnd.ms-excel", // Excel (.xls)
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // Excel (.xlsx)
    "application/vnd.ms-powerpoint", // PowerPoint (.ppt)
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // PowerPoint (.pptx)
    "application/vnd.oasis.opendocument.text", // OpenDocument Text (.odt)
    "application/vnd.oasis.opendocument.spreadsheet", // OpenDocument Spreadsheet (.ods)
    "text/plain",      // Plain text (.txt)
    "text/csv"         // CSV
];
